// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3CgFa","name":"ConsentHeader_name__1xP1S","birthday":"ConsentHeader_birthday__JlDC7","skeleton":"ConsentHeader_skeleton__2ls4N"};